import { createMuiTheme } from '@material-ui/core'
import fonts from '../assets/fonts'
import getQueryStringValue from './getQueryStringValue'

const binleumi = {
  primary: {
    main: '#ffba2f',
    light: '#ffe89c',
    dark: '#fca31c',
  },
  secondary: {
    main: '#002558',
    light: '#204f78',
    dark: '#000e6b',
  },
  background: {
    default: '#f3f4fc',
    paper: '#f8f9fd',
  },
}

const leumi = {
  primary: {
    main: '#58b2e8',
    light: '#0293e9',
    dark: '#0293e9',
  },
  secondary: {
    main: '#01448f',
    light: '#204f78',
    dark: '#000e6b',
  },
  background: {
    default: '#f3f4fc',
    paper: '#f8f9fd',
  },
}

const mizrahi = {
  primary: {
    main: '#fe8233',
    light: '#ff9b61',
    dark: '#ad4203',
  },
  secondary: {
    main: '#3f535c',
    light: '#9bbbc9',
    dark: '#182c36',
  },
  background: {
    default: '#f3f4fc',
    paper: '#f8f9fd',
  },
}

const themes = {
  mizrahi,
  leumi,
  binleumi,
}

const {
  interRegular,
  interSemiBold,
  interBold,
  muliRegular,
  muliBold,
  arimoHeRegulrar,
  arimoHeBold,
} = fonts

export default createMuiTheme({
  palette: themes[getQueryStringValue('theme')] || binleumi,
  typography: {
    fontFamily: 'Inter, Muli, Arimo, sans-serif',
  },
  overrides: {
    MuiPaper: {
      root: {
        display: 'flex',
        flexDirection: 'column',
      },
    },
    MuiButton: {
      root: {
        textTransform: 'none',
      },
      containedSecondary: {
        color: 'white',
      },
    },
    MuiCssBaseline: {
      '@global': {
        '*': {
          outline: 'none',
        },
        '#gtx-trans': { // hide google translate widget on text selection
          display: 'none',
        },
        '@font-face': [
          interRegular,
          interSemiBold,
          interBold,
          muliRegular,
          muliBold,
          arimoHeRegulrar,
          arimoHeBold,
        ],
        body: {
          margin: 0,
        },
      },
    },
  },
})
